import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0548 = React.lazy(() => import('./symbols/0548_dont_touch_dangerous_stop_caution'));
const Symbol0549 = React.lazy(() => import('./symbols/0549_dont_touch_dangerous_stop_caution'));
const Symbol0550 = React.lazy(() => import('./symbols/0550_attention_error_alert_caution'));
const Symbol0551 = React.lazy(() => import('./symbols/0551_information_about'));
const Symbol0552 = React.lazy(() => import('./symbols/0552_about_question_faq_help'));
const Symbol0553 = React.lazy(() => import('./symbols/0553_radioactive_nuclear_danger_atom'));
const Symbol0554 = React.lazy(() => import('./symbols/0554_fire_danger_hot_flammable'));
const Symbol0555 = React.lazy(() => import('./symbols/0555_fire_extinguisher'));
const Symbol0556 = React.lazy(() => import('./symbols/0556_poison_danger_death_caution'));
const Symbol0557 = React.lazy(() => import('./symbols/0557_men_women_toilet_wc_restroom'));
const Symbol0558 = React.lazy(() => import('./symbols/0558_men_women_toilet_wc_restroom'));
const Symbol0559 = React.lazy(() => import('./symbols/0559_smoking_allowed_cigarettes'));
const Symbol0560 = React.lazy(() => import('./symbols/0560_smoking_forbidden_cigarettes'));
const Symbol0561 = React.lazy(() => import('./symbols/0561_guns_arms_forbidden'));
const Symbol0562 = React.lazy(() => import('./symbols/0562_dogs_pets_forbidden'));
const Symbol0563 = React.lazy(() => import('./symbols/0563_handicapped'));
const Symbol0564 = React.lazy(() => import('./symbols/0564_flight_departure_airport_airplane'));
const Symbol0565 = React.lazy(() => import('./symbols/0565_flight_arrival_airport_airplane'));
const Symbol0566 = React.lazy(() => import('./symbols/0566_trash_bin_garbage'));
const Symbol0567 = React.lazy(() => import('./symbols/0567_elevator_up_down'));
const Symbol0568 = React.lazy(() => import('./symbols/0568_steps_upstairs'));
const Symbol0569 = React.lazy(() => import('./symbols/0569_steps_downstairs'));
const Symbol0570 = React.lazy(() => import('./symbols/0570_rolling_stairs_up'));
const Symbol0571 = React.lazy(() => import('./symbols/0571_rolling_stairs_down'));
const Symbol0572 = React.lazy(() => import('./symbols/0572_down'));
const Symbol0573 = React.lazy(() => import('./symbols/0573_up'));
const Symbol0574 = React.lazy(() => import('./symbols/0574_out_exit_emergency_logout'));
const Symbol0575 = React.lazy(() => import('./symbols/0575_out_exit_emergency_logout'));
const Symbol0576 = React.lazy(() => import('./symbols/0576_door_exit_emergency_logout'));
const Symbol0577 = React.lazy(() => import('./symbols/0577_information_desk_support_help'));
const Symbol0578 = React.lazy(() => import('./symbols/0578_information_office_desk_support_help'));
const Symbol0579 = React.lazy(() => import('./symbols/0579_speech_presentation'));
const Symbol0580 = React.lazy(() => import('./symbols/0580_changing_diapers_baby'));
const Symbol0581 = React.lazy(() => import('./symbols/0581_take_ticket_vote_box'));
const Symbol0582 = React.lazy(() => import('./symbols/0582_take_ticket_waiting_room'));
const Symbol0583 = React.lazy(() => import('./symbols/0583_take_ticket'));
const Symbol0584 = React.lazy(() => import('./symbols/0584_wheelchair_access'));
const Symbol0585 = React.lazy(() => import('./symbols/0585_wheelchair_ramp'));

export interface IProps {}

const Signs: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0548_dont_touch_dangerous_stop_caution" symbol={<Symbol0548 />} />
      <LazySymbol id="0549_dont_touch_dangerous_stop_caution" symbol={<Symbol0549 />} />
      <LazySymbol id="0550_attention_error_alert_caution" symbol={<Symbol0550 />} />
      <LazySymbol id="0551_information_about" symbol={<Symbol0551 />} />
      <LazySymbol id="0552_about_question_faq_help" symbol={<Symbol0552 />} />
      <LazySymbol id="0553_radioactive_nuclear_danger_atom" symbol={<Symbol0553 />} />
      <LazySymbol id="0554_fire_danger_hot_flammable" symbol={<Symbol0554 />} />
      <LazySymbol id="0555_fire_extinguisher" symbol={<Symbol0555 />} />
      <LazySymbol id="0556_poison_danger_death_caution" symbol={<Symbol0556 />} />
      <LazySymbol id="0557_men_women_toilet_wc_restroom" symbol={<Symbol0557 />} />
      <LazySymbol id="0558_men_women_toilet_wc_restroom" symbol={<Symbol0558 />} />
      <LazySymbol id="0559_smoking_allowed_cigarettes" symbol={<Symbol0559 />} />
      <LazySymbol id="0560_smoking_forbidden_cigarettes" symbol={<Symbol0560 />} />
      <LazySymbol id="0561_guns_arms_forbidden" symbol={<Symbol0561 />} />
      <LazySymbol id="0562_dogs_pets_forbidden" symbol={<Symbol0562 />} />
      <LazySymbol id="0563_handicapped" symbol={<Symbol0563 />} />
      <LazySymbol id="0564_flight_departure_airport_airplane" symbol={<Symbol0564 />} />
      <LazySymbol id="0565_flight_arrival_airport_airplane" symbol={<Symbol0565 />} />
      <LazySymbol id="0566_trash_bin_garbage" symbol={<Symbol0566 />} />
      <LazySymbol id="0567_elevator_up_down" symbol={<Symbol0567 />} />
      <LazySymbol id="0568_steps_upstairs" symbol={<Symbol0568 />} />
      <LazySymbol id="0569_steps_downstairs" symbol={<Symbol0569 />} />
      <LazySymbol id="0570_rolling_stairs_up" symbol={<Symbol0570 />} />
      <LazySymbol id="0571_rolling_stairs_down" symbol={<Symbol0571 />} />
      <LazySymbol id="0572_down" symbol={<Symbol0572 />} />
      <LazySymbol id="0573_up" symbol={<Symbol0573 />} />
      <LazySymbol id="0574_out_exit_emergency_logout" symbol={<Symbol0574 />} />
      <LazySymbol id="0575_out_exit_emergency_logout" symbol={<Symbol0575 />} />
      <LazySymbol id="0576_door_exit_emergency_logout" symbol={<Symbol0576 />} />
      <LazySymbol id="0577_information_desk_support_help" symbol={<Symbol0577 />} />
      <LazySymbol id="0578_information_office_desk_support_help" symbol={<Symbol0578 />} />
      <LazySymbol id="0579_speech_presentation" symbol={<Symbol0579 />} />
      <LazySymbol id="0580_changing_diapers_baby" symbol={<Symbol0580 />} />
      <LazySymbol id="0581_take_ticket_vote_box" symbol={<Symbol0581 />} />
      <LazySymbol id="0582_take_ticket_waiting_room" symbol={<Symbol0582 />} />
      <LazySymbol id="0583_take_ticket" symbol={<Symbol0583 />} />
      <LazySymbol id="0584_wheelchair_access" symbol={<Symbol0584 />} />
      <LazySymbol id="0585_wheelchair_ramp" symbol={<Symbol0585 />} />
    </>
  );
});

Signs.displayName = 'Signs';

export default Signs;
